export const [SA_STATS_SUCCESS, UPDATE_SEARCH_PROPOSAL_NO, PROPOSAL_SEARCH_SUCCESS, PROPOSAL_SEARCH_FAILED] =
    ['SA_STATS_SUCCESS', 'UPDATE_SEARCH_PROPOSAL_NO', 'PROPOSAL_SEARCH_SUCCESS', 'PROPOSAL_SEARCH_FAILED']
